import globalAxios from "../../../util/Api";
import { GET_BRANCHES, DELETE_BRANCH, CREATE_BRANCH, EDIT_BRANCH, START_LOADING, STOP_LOADING, ACCESS_RIGHT_ERROR, BRANCH_ERROR } from "./types";
import { LogoutAction } from "../../../actions";

export const GetBranches = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/branches`)
      .then(res => {
        const newres = res.data.branches.map(obj => {
          obj['name'] = obj['branch']
          delete obj['branch']
          return obj
        })
        if (newres) {
          dispatch({ type: GET_BRANCHES, payload: newres })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const CreateBranch = (branchName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('branch[branch]', branchName);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/branches`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['branch']
        delete newres['branch']
        if (newres) {
          dispatch({ type: CREATE_BRANCH, payload: newres })
          dispatch(GetBranches())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: BRANCH_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: BRANCH_ERROR, payload: err.message })
      })
  }
}
export const EditBranch = (id, branchName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('branch[branch]', branchName);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().patch(`/api/v1/branches/${id}`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['branch']
        delete newres['branch']
        if (newres) {
          dispatch({ type: EDIT_BRANCH, payload: newres })
          dispatch(GetBranches())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: BRANCH_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: BRANCH_ERROR, payload: err.message })
      })
  }
}
export const DeleteBranch = (id) => {

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/branches/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_BRANCH })
          dispatch(GetBranches())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: BRANCH_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: BRANCH_ERROR, payload: err.message })
      })
  }
}
